import { createContext } from 'react'
import type { Language } from '../lib/format'

export interface TranslationValue {
  t: (key: string) => string
  lang: Language
  locale: string
}

export const TranslationContext = createContext<TranslationValue>({
  t: (key) => key,
  lang: 'en',
  locale: 'en-US',
})
